// RADAR jobs as the API returns them (services/api/src/radar/service.ts view()).
export type RadarType = "COMPASS_EXPORT" | "TIMERECORD" | "REGISTER";
export type RadarStatus = "SUBMITTED" | "RUNNING" | "COMPLETED" | "FAILED";

export interface RadarJob {
  jobId: string;
  type: RadarType;
  status: RadarStatus;
  connId: string;
  by: string;
  createdAt: string;
  updatedAt: string;
  queryId?: string;
  outputBytes?: number;
  hasOutput: boolean;
  request: { pushToInfor: boolean; reportName?: string; distProfile?: string; model?: string; version?: string; maxResponseTokens?: number; temperature?: number };
  resolved?: { model: string; version: string; maxResponseTokens: number; temperature: number };
  usage?: Record<string, number | string>;
  estimatedUsage?: boolean;
  elapsedSeconds?: number;
  warnings?: string[];
  rows?: number;
  push?: { printManagerDocumentId?: string; printManagerError?: string; userReportId?: string; userReportLookupError?: string; distributed?: boolean; userReportError?: string };
  error?: string;
  runId?: string;
  stepId?: string;
}

export const TYPE_LABEL: Record<RadarType, string> = { COMPASS_EXPORT: "Compass export", TIMERECORD: "Time record report", REGISTER: "Payroll register report" };
export const STATUS_LABEL: Record<RadarStatus, string> = { SUBMITTED: "Submitted", RUNNING: "Running", COMPLETED: "Complete", FAILED: "Failed" };
export const STATUS_TONE: Record<RadarStatus, string> = { SUBMITTED: "bg-accent-soft text-accent-text", RUNNING: "bg-accent-soft text-accent-text", COMPLETED: "bg-good-soft text-good", FAILED: "bg-bad-soft text-bad" };
export const active = (j: RadarJob) => j.status === "SUBMITTED" || j.status === "RUNNING";
export const when = (iso?: string) => (iso ? new Date(iso).toLocaleString() : "");
export const size = (n?: number) => (n === undefined ? "" : n < 1024 ? `${n} B` : n < 1024 * 1024 ? `${(n / 1024).toFixed(1)} KB` : `${(n / 1024 / 1024).toFixed(1)} MB`);
export const jobName = (j: RadarJob) => j.request.reportName || TYPE_LABEL[j.type];
